// src/utils/markerStatus.js
//
// A single source of truth for "marker status → badge class". Before this,
// the same normal/elevated/low/high/critical vocabulary was independently
// reinvented in at least four places (PatientTriageResultPage's MarkerPill,
// MarkerTrendWidget's STATUS_COLOR, DoctorPatientDetailPage's STATUS_DOT, and
// implicitly wherever a page reached for its own badge colors) — each with
// slightly different coverage and no shared name for the concept.
//
// Reuses the badge classes index.css already ships as "clinical risk
// vocabulary" (badge-low/moderate/critical/unknown) rather than inventing a
// marker-specific palette — see the comment above those classes in index.css.
//
// "low" is deliberately NOT mapped to badge-low: badge-low means "low RISK"
// (green, a good outcome), but marker status "low" means "the measured value
// is low" (e.g. low HDL, low B12), which is a finding to note, not a good
// outcome — mapping it to green would misread as reassuring. Matches the
// existing distinction DoctorPatientDetailPage's STATUS_DOT already drew
// (low got its own blue dot, never green) — badge-confirmed is this
// stylesheet's blue, so it plays that same informational-not-reassuring role.
const STATUS_BADGE_CLASS = {
  optimal:  'badge-low',
  normal:   'badge-low',
  low:      'badge-confirmed',
  elevated: 'badge-moderate',
  high:     'badge-critical',
  critical: 'badge-critical',
};

export function markerStatusBadgeClass(status) {
  if (!status) return 'badge-unknown';
  return STATUS_BADGE_CLASS[status.toLowerCase()] || 'badge-unknown';
}

export function markerStatusLabel(status) {
  if (!status) return 'Unknown';
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
}
